import { API_URL } from "../constants";
import { getHeaders } from "../utils";

export const getInviteList = async ({ propertyId, unitId }) => {
  const response = await fetch(
    `${API_URL}/api/properties/${propertyId}/units/${unitId}/invites`,
    {
      method: "GET",
      headers: getHeaders(),
    }
  );
  return response.json();
};

export const createInviteWrapper = async ({
  propertyId,
  unitId,
  email,
  firstName,
  lastName,
}) => {
  const invites = await getInvites({ propertyId, unitId });
  if (invites && invites.length > 0 && invites[0].id) {
    const invite = invites[0];
    await deleteInvite({ propertyId, unitId, inviteId: invite.id })
  }
  const response = await createInvite({
    propertyId,
    unitId,
    email,
    firstName,
    lastName,
  })
  return response
}

export const createInvite = async ({
  propertyId,
  unitId,
  email,
  firstName,
  lastName,
}) => {
  const response = await fetch(
    `${API_URL}/api/properties/${propertyId}/units/${unitId}/invites`,
    {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify({ email, firstName, lastName }),
    }
  );
  return response.json();
};

export const getInvites = async ({  propertyId, unitId }) => {
  const response = await fetch(
    `${API_URL}/api/properties/${propertyId}/units/${unitId}/invites/`,
    {
      method: "GET",
      headers: getHeaders(),
    }
  );
  return response.json();
};

export const deleteInvite = async ({ propertyId, unitId, inviteId }) => {
  return await fetch(
    `${API_URL}/api/properties/${propertyId}/units/${unitId}/invites/${inviteId}`,
    {
      method: "DELETE",
      headers: getHeaders(),
    }
  );
};
